import moment from "moment/moment";
import SimpleModal from "../../../components/SimpleModal/SimpleModal";
import { AvailabilityListForm } from "./AvailabilityListForm";
import { useState } from "react";
import { showWarning } from "../../../services/ModalService";
import { toast } from "react-toastify";

export function DetailsAvailabilityList({
  availabilityList,
  t,
  validate,
  onClose,
  isOpen,
  setAvailabilityList,
  AvailabilitiesListService,
  processResponse,
  error,
  docStatus,
  docStatusLabel,
  contractTypes
}) {
  const [showEditForm, setShowEditForm] = useState(false);
  const AVAILABILITYTYPE = { immediate: 1, fixedDate: 2, preNotice: 3 };
  
  function deleteAvailabilityList() {
    showWarning(
      t("Are you sure you want to delete this availability list?"),
      () => {
        AvailabilitiesListService.deleteAvailabiltiesList(
          availabilityList.availabilityId,
          availabilityList.interviewId
        ).then((data) => {
          processResponse(data);

          toast.success(t("Availability deleted successfully"));

          onClose();
        }).catch((error) => {
          console.error("Error deleting availability:", error);
        });
      }
    );
  }

  function updateavailabilitiesListCandidate() {
    if (validate()) {
      AvailabilitiesListService.updateAvailabiltiesList(
        availabilityList
      ).then((data) => {
        processResponse(data);

        toast.success(t("Availability updated successfully"));

        onClose();
        setShowEditForm(false);
      }).catch((error) => {
        console.error("Error updating availability:", error);
      });
    }
  }

  function onCancelModal() {
    setShowEditForm(false);
    onClose();
  }

  function customFooter() {
    return (
      <div className="simple-modal-actions-right col">
        <button
          className="btn btn-second m-1 col-2"
          onClick={showEditForm ? onCancelModal : deleteAvailabilityList}
        >
          {showEditForm ? t("Cancel") : t("Delete")}
        </button>
        <button
          className="btn btn-prime m-1 col-2"
          onClick={
            showEditForm
              ? updateavailabilitiesListCandidate
              : () => setShowEditForm(true)
          }
        >
          {showEditForm ? t("Save") : t("Edit")}
        </button>
      </div>
    );
  }

  return (
    <div>
      <SimpleModal
        customFooter={customFooter}
        isOpen={isOpen}
        onClose={onCancelModal}
        title={
          showEditForm
            ? t("The candidate will be available,do you want to proceed?")
            : t("Details")
        }
        size={"md"}
      >
        {showEditForm ? (
          <AvailabilityListForm
            availabilityList={availabilityList}
            setAvailabilityList={setAvailabilityList}
            t={t}
            error={error}
            validate={validate}
            docStatus={docStatus}
            docStatusLabel={docStatusLabel}
            contractTypes={contractTypes}
          />
        ) : (
          <div style={{ height: "400px", overflowY: "auto" }}>
            <div className="row m-2">
              <div className="col-3">{t("Skills")}</div>
              <div className="col">
                <strong>{availabilityList.skills}</strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Disponibility Type")}</div>
              <div className="col">
                <strong>
                  {" "}
                  {availabilityList.availabilityTypeDescription}{" "}
                  {availabilityList.availabilityType ===
                    AVAILABILITYTYPE.fixedDate &&
                    moment(availabilityList.availabilityDate).format(
                      "DD/MM/yyyy"
                    )}
                  {availabilityList.availabilityType ===
                    AVAILABILITYTYPE.preNotice &&
                    availabilityList.numberOfWeeks}
                </strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Observations")}</div>
              <div className="col">
                <strong>{availabilityList.comment}</strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Contract Type")}</div>
              <div className="col">
                <strong>{availabilityList.userContractTypeName}</strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Is Available Group")}</div>
              <div className="col">
                <strong>{availabilityList.forAll ? t("Yes") : t("No")}</strong>
              </div>
            </div>{" "}
            <div className="row m-2">
              <div className="col-3 text-start">{t("Created By")}</div>
              <div className="col">
                <strong>{availabilityList.createdBy}</strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Created At")}</div>
              <div className="col-3">
                <strong>
                  {availabilityList.createdAt &&
                    moment(availabilityList.createdAt).format("DD/MM/yyyy")}
                </strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Update By")}</div>
              <div className="col">
                <strong>{availabilityList.updatedBy}</strong>
              </div>
            </div>
            <div className="row m-2">
              <div className="col-3">{t("Update At")}</div>
              <div className="col">
                <strong>
                  {moment(availabilityList.updatedAt).format("DD/MM/yyyy") !==
                    "01/01/0001" &&
                    moment(availabilityList.updatedAt).format("DD/MM/yyyy")}
                </strong>
              </div>
            </div>
          </div>
        )}
      </SimpleModal>
    </div>
  );
}
